import { $ } from './../helpers/query'
import {HeroAnimation} from './section-animation/HeroAnimation'
import {IntroAnimation} from './section-animation/IntroAnimation'
import {PhotosAnimation} from './section-animation/PhotosAnimation'
import {MapIntroAnimation} from './section-animation/MapIntroAnimation'
import {MapAnimation} from './section-animation/MapAnimation'
import {FeaturesAnimation} from './section-animation/FeaturesAnimation'
import {BuildingIntroAnimation} from './section-animation/BuildingIntroAnimation'
import {BuildingAnimation} from './section-animation/BuildingAnimation'
import {SpecificationsIntroAnimation} from './section-animation/SpecificationsIntroAnimation'
import {SpecificationsAnimation} from './section-animation/SpecificationsAnimation'
import {SustainabilityIntroAnimation} from './section-animation/SustainabilityIntroAnimation'
import {SustainabilityAnimation} from './section-animation/SustainabilityAnimation'
import {GalleryAnimation} from './section-animation/GalleryAnimation'
import {DownloadsAnimation} from './section-animation/DownloadsAnimation'
import {FooterAnimation} from './section-animation/FooterAnimation'

export default class {
  constructor() {
    this.heroAnim = new HeroAnimation();
    this.introAnim = new IntroAnimation();
    this.photosAnim = new PhotosAnimation();
    this.mapIntroAnim = new MapIntroAnimation();
    this.mapAnim = new MapAnimation();
    this.featuresAnim = new FeaturesAnimation();
    this.buildIntroAnim = new BuildingIntroAnimation();
    this.buildAnim = new BuildingAnimation();
    this.specIntroAnim = new SpecificationsIntroAnimation();
    this.specAnim = new SpecificationsAnimation();
    this.sustIntroAnim = new SustainabilityIntroAnimation();
    this.sustAnim = new SustainabilityAnimation();
    this.galleryAnim = new GalleryAnimation();
    this.downloadAnim = new DownloadsAnimation();
    this.footerAnim = new FooterAnimation();
  }

  init() {
    this.heroAnim.show()
  }
}
